module.exports = __webpack_public_path__ + "img/sc.aec1be20.svg";